import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const Nav = styled.nav`
  background-color: var(--bg-page);
  width: 100%;
  z-index: 1000;
  border-bottom: 1px solid var(--color-border);
  position: sticky;
  top: 0;
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  max-width: var(--container-width);
  margin: 0 auto;
  padding: 14px 24px;

  @media (max-width: 768px) {
    padding: 12px 16px;
    gap: 10px;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 28px;

  a {
    font-family: var(--font-system);
    font-weight: 400;
    font-size: 0.9375rem;
    color: var(--color-text-muted);
    text-decoration: none;
    transition: color 0.15s ease;

    &:hover {
      color: var(--color-accent);
    }

    &.active {
      color: var(--color-text);
      font-weight: 500;
    }

    @media (max-width: 768px) {
      font-size: 0.875rem;
    }
  }
`;

const Navbar = () => {
  const location = useLocation();
  const [, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Nav>
      <NavContainer>
        <NavLinks>
          <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
            Home
          </Link>
          <Link
            to="/methodology"
            className={location.pathname === '/methodology' ? 'active' : ''}
          >
            Methodology
          </Link>
        </NavLinks>
      </NavContainer>
    </Nav>
  );
};

export default Navbar;
